const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/settings/general/home-page/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { SetStateFn } from '@/Types';
import { type Content_List_Query$variables } from '@/graphql/queries/Content.query';
import { type Znglist_List_Query$variables } from '@/graphql/queries/Znglist.query';
import { createFileRoute } from '@tanstack/react-router';
import type { DeepNonNullable } from 'ts-essentials';
import type { homePage_Settings_Fragment$data } from './__generated__/homePage_Settings_Fragment.graphql';
type SiteState = DeepNonNullable<homePage_Settings_Fragment$data['pinning']>;
type FetchSelect<T extends SiteState> = {
  state: T;
  setState: SetStateFn<T>;
  commitProps: ReturnType<typeof useSettingsUtil<SiteState, SiteState>>['commitProps'];
};
export const Route = createFileRoute('/dash/settings/general/home-page/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});